import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  GECKO_CONSTS,
  GECKO_UTILS,
  GeckoModal,
  GeckoToastService,
  GeckoAvatar,
  GeckoFields,
  GeckoModalService,
  GeckoBtn,
  GeckoDropdown,
} from 'ui';

import { fromNow } from 'utilities/fromNowWrapper.js';
import GeckoRequest from 'services/gecko-request';
import Loader from 'components/Loader';
import Phone from 'react-phone-number-input';
import DraftDisplay from 'components/DraftDisplay';
import GeckoDates from 'services/gecko-date';
import GeckoLocation from 'services/gecko-location';
import ComposeModal from 'routes/conversations/components/ComposeModal';
import ContactMergeModal from 'components/ContactMergeModal';
import { handleDeleteContact } from '../../conversations/utils';
import { onlyUnarchivedSelectableOptions } from 'utilities/customFieldUtils';
import { CONSTS } from 'constants/index.js';

import 'react-phone-number-input/style.css';
import './ContactModal.scss';

class ChatHead extends Component {
  openConversation() {
    new GeckoModalService().close();
    return GeckoLocation.goTo(`/conversations/${this.props.conversation_id}`, {
      filter: CONSTS.FILTER_CONTACT,
      contact: this.props.contact.id,
    });
  }

  render() {
    const {
      contact,
      last_message_time,
      last_message_channel = {},
    } = this.props;
    const channelName = last_message_channel.name || 'Unknown';

    return (
      <div
        className="ContactModal-ChatHead"
        onClick={this.openConversation.bind(this)}
      >
        <div className="chat-head-avatar">
          <GeckoAvatar
            name={contact.full_name}
            first_name={contact.first_name}
            last_name={contact.last_name}
            color={contact.additional.avatar_colour}
            bgImage={contact.additional.profile_picture_url}
          />
        </div>
        <div>
          <div className="chat-head-title">{contact.full_name}</div>
          <div className="chat-head-time">
            <span className="chat-head-channel">
              {fromNow(last_message_time) || 'Never'} via {channelName}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

class ContactModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingContact: false,
      contact: { custom_fields: {} },
      conversations: [],
    };
  }

  componentDidMount() {
    this.setState({ loadingContact: true });
    GeckoRequest.get(`/contact/${this.props.contact_id}/view-modal`)
      .then(([contact, conversations]) => {
        this.setState({ contact, conversations, loadingContact: false });
      })
      .catch((err) => {
        new GeckoToastService().error(err);
        this.setState({ loadingContact: false });
      });
  }

  handleChange(key, value) {
    const contact = GECKO_UTILS.setNestedValue(this.state.contact, key, value);
    this.setState({ contact });
  }

  openComposeModal() {
    // new GeckoModalService().close()
    const { contact } = this.state;
    const sendTo = contact.email || contact.tel;

    new GeckoModalService().open(
      () => {
        return <ComposeModal contactOverride={contact} sendTo={[sendTo]} />;
      },
      { backdrop: 'static' }
    );
  }

  openMergeModal() {
    new GeckoModalService().open(() => (
      <ContactMergeModal contact_id={this.state.contact.id} />
    ));
  }

  render() {
    const fields = this.props.fields.map((field) => {
      if (field.type === 'telephone' || field.key === 'tel') {
        return {
          label: field.label,
          key: field.custom_field ? `custom_fields.${field.id}` : field.key,
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          component: <Phone placeholder="Enter phone number" />,
          width: '100%',
          order: field.order,
        };
      }
      if (field.type === 'display') {
        return {
          label: field.label,
          key: field.custom_field ? `custom_fields.${field.id}` : field.key,
          type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
          component: <DraftDisplay editorObject={field.editor_object} />,
          width: '100%',
          order: field.order,
        };
      }
      if (field.type === 'date') {
        return {
          label: field.label,
          key: field.custom_field ? `custom_fields.${field.id}` : field.key,
          type: field.type,
          width: '100%',
          order: field.order,
          format: 'X',
          enableUTC: true,
          display_format: new GeckoDates().FORMATS.SHORT,
          placeholder: new GeckoDates().FORMATS.SHORT,
        };
      }
      return {
        label: field.label,
        key: field.custom_field ? `custom_fields.${field.id}` : field.key,
        type: field.type,
        options: field.field_options
          ? onlyUnarchivedSelectableOptions(field.field_options)
          : null,
        width: '100%',
        order: field.order,
      };
    });

    const buttons = [
      {
        name: 'Save Changes',
        preset: GECKO_CONSTS.BTN_PRESET_SAVE,
        primary: true,
        handler: () => {
          GeckoRequest.post(
            `/models/contacts/${this.state.contact.id}`,
            this.state.contact
          )
            .then(() => {
              new GeckoToastService().success('Contact has been updated');
              new GeckoModalService().close();
            })
            .catch((err) => {
              new GeckoToastService().error(err);
            });
        },
      },
    ];

    const dropdownItems = [
      {
        name: 'Merge Contact',
        handler: this.openMergeModal.bind(this),
      },
      {
        name: 'Delete Contact',
        handler: () => {
          handleDeleteContact(this.state.contact.id);
        },
      },
    ];

    return (
      <GeckoModal name={this.state.contact.full_name} btns={buttons}>
        <Loader isLoading={this.state.loadingContact}>
          <div className="ContactModal">
            <div
              className={`ContactModal-header-buttons ${
                this.state.contact.email || this.state.contact.tel
                  ? 'has-compose-button'
                  : ''
              }`}
            >
              {this.state.contact.email || this.state.contact.tel ? (
                <GeckoBtn
                  name="Compose"
                  icon="far fa-edit"
                  handler={this.openComposeModal.bind(this)}
                />
              ) : null}
              <GeckoDropdown
                align="right"
                type="outline-primary"
                icon="fas fa-ellipsis-h"
                items={dropdownItems}
              />
            </div>
            {this.state.conversations.length ? (
              <div>
                <label className="ContactModal-conversation-label">
                  Conversations
                </label>
                <div className="ContactModal-chat-heads">
                  {this.state.conversations.map((conversation) => {
                    const channel = this.props.channels.find(
                      (channel) =>
                        channel.id === conversation.last_message_channel
                    );
                    return (
                      <ChatHead
                        key={conversation.id}
                        last_message_time={conversation.last_message_time}
                        last_message_channel={channel}
                        contact={this.state.contact}
                        conversation_id={conversation.id}
                      />
                    );
                  })}
                </div>
              </div>
            ) : null}
            <div className="ContactModal-contact-details">
              <GeckoFields
                fields={fields}
                values={this.state.contact}
                handler={this.handleChange.bind(this)}
              />
            </div>
          </div>
        </Loader>
      </GeckoModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    channels: state.channels,
    fields: state.fields.sort((f1, f2) => f1.order - f2.order),
  };
};
export default connect(mapStateToProps)(ContactModal);
